import type { ReactNode } from 'react';
import './Cartao.css';

type Props = {
  /** Conteúdo do cabeçalho do cartão (18/600 no corpo do painel). */
  readonly titulo?: ReactNode;
  /** Canto direito do cabeçalho: contador, link "Ver tudo", legenda. */
  readonly acessorio?: ReactNode;
  readonly tom?: 'padrao' | 'atencao' | 'sucesso';
  /** Conteúdo colado às bordas — para listas e tabelas que já têm respiro. */
  readonly semRespiro?: boolean;
  readonly children: ReactNode;
};

/** Bloco branco padrão do painel: borda de 1px, raio de 10px, sem sombra. */
export function Cartao({ titulo, acessorio, tom = 'padrao', semRespiro = false, children }: Props) {
  return (
    <section className="cartao">
      {titulo !== undefined && (
        <div className={`cartao__cabecalho cartao__cabecalho--${tom}`}>
          <h2 className="cartao__titulo">{titulo}</h2>
          {acessorio !== undefined && <div className="cartao__acessorio">{acessorio}</div>}
        </div>
      )}
      <div className={semRespiro ? 'cartao__corpo cartao__corpo--colado' : 'cartao__corpo'}>
        {children}
      </div>
    </section>
  );
}
